import { render, staticRenderFns } from "./UserTitle.vue?vue&type=template&id=15b1856d&scoped=true&"
import script from "./UserTitle.vue?vue&type=script&lang=js&"
export * from "./UserTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1856d",
  null
  
)

export default component.exports